import * as dateFNS from "date-fns";
import { Input, Label } from "./styles";

export default function ExpirationDate({ date, onChangeDate = () => null }) {
  return (
    <Label>
      <span>Prazo de acesso (Opcional)</span>
      <Input
        type="date"
        min={dateFNS.format(new Date(), 'yyyy-MM-dd')}
        value={date}
        onChange={(e) => onChangeDate(e.target.value)}
      />
    </Label>
  );
}
